// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-already-has-account .page-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 130%;
}

.page-already-has-account .steps-container {
  max-width: 450px;
}

.page-already-has-account .steps-container a {
  color: var(--main-highlight-color);
  text-decoration: underline;
}

.page-already-has-account .manual-step {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.page-already-has-account .manual-step .step-icon {
  --step-icon-size: 22px;
  position: relative;
  margin-right: 12px;

  display: flex;
  justify-content: center;
  align-items: center;

  height: var(--step-icon-size);
  width: var(--step-icon-size);
  min-width: var(--step-icon-size);
  background-color: #aeaeb4;
  border-radius: 50%;
}

.page-already-has-account .manual-step .step-icon svg {
  position: absolute;
  top: 0;
  left: 0;
  height: var(--step-icon-size);
  width: var(--step-icon-size);
}

.page-already-has-account .manual-step .step-number {
  color: white;
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  padding-top: 2px;
}

.page-already-has-account .manual-step .text {
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}

.page-already-has-account .button-container {
  margin-top: 50px;
  padding: 0 30px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/already-has-account.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,6BAA6B;EAC7B,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".page-already-has-account .page-title {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 130%;\n}\n\n.page-already-has-account .steps-container {\n  max-width: 450px;\n}\n\n.page-already-has-account .steps-container a {\n  color: var(--main-highlight-color);\n  text-decoration: underline;\n}\n\n.page-already-has-account .manual-step {\n  display: flex;\n  align-items: center;\n  margin-top: 16px;\n}\n\n.page-already-has-account .manual-step .step-icon {\n  --step-icon-size: 22px;\n  position: relative;\n  margin-right: 12px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: var(--step-icon-size);\n  width: var(--step-icon-size);\n  min-width: var(--step-icon-size);\n  background-color: #aeaeb4;\n  border-radius: 50%;\n}\n\n.page-already-has-account .manual-step .step-icon svg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: var(--step-icon-size);\n  width: var(--step-icon-size);\n}\n\n.page-already-has-account .manual-step .step-number {\n  color: white;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 12px;\n  padding-top: 2px;\n}\n\n.page-already-has-account .manual-step .text {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.page-already-has-account .button-container {\n  margin-top: 50px;\n  padding: 0 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
